import React from 'react';

/**
 * Who is looking at the inbox.
 *
 * The login flow writes `user` to local or session storage (services/api.js);
 * that is the copy the rest of the app reads, so it is the copy read here. The
 * server never trusts it — `viewerIsOwner` and every send are decided there —
 * this only labels things ("You", "Mine") and namespaces per-browser
 * preferences.
 */
export function currentUserId() {
	try {
		const raw = localStorage.getItem('user') || sessionStorage.getItem('user');
		const id = raw ? JSON.parse(raw)?._id : null;
		return id ? String(id) : null;
	} catch (_) {
		return null;
	}
}

export default function useCurrentUserId() {
	// Stable for the life of the session; a login change reloads the app.
	return React.useMemo(currentUserId, []);
}
